export default [
  {
    Link: "/articles",
    Title: "Blog",
  },
]
